
export type EnvironmentType = "trimble-prod" | "trimble-pre-prod";
export const IDENTITY_ENVIRONMENT_TYPE = {
    PRE_PRODUCTION: "trimble-pre-prod" as EnvironmentType,
    PRODUCTION: "trimble-prod" as EnvironmentType
} as const;

export const DEFAULT_IDENTITY_ENVIRONMENT : EnvironmentType = process.env.REACT_APP_DEFAULT_IDENTITY_ENVIRONMENT === "trimble-prod" ? "trimble-prod" : "trimble-pre-prod";
export const isNewConsoleSepFlow = process.env.REACT_APP_NEW_ENVIRONMENT_SEPERATION === "true" ? true : false;
